import PropTypes from 'prop-types';
import React from 'react';
import { FAIcon } from '@everfi/reactifi/src/components/fa-icon';

export default class Ibox extends React.Component {
  static propTypes = {
    tools: PropTypes.node,
    collapse: PropTypes.bool,
    children: PropTypes.node.isRequired,
    title: PropTypes.node,
    showTitle: PropTypes.bool,
    titleWithMarkup: PropTypes.object,
    iboxClass: PropTypes.string,
    showAsDragable: PropTypes.bool,
  };

  static defaultProps = {
    showTitle: true,
  };

  titleContent = () => {
    const { title, titleWithMarkup, tools } = this.props;
    return (
      <header>
        {titleWithMarkup ? <div>{titleWithMarkup}</div> : null}
        {title ? <h2 className="mimic-header">{title}</h2> : null}
        {tools ? (
          <>
            <div className="pull-right">{tools}</div>
            <div className="clearfix" />
          </>
        ) : null}
      </header>
    );
  };

  renderIBoxContent = () => {
    const contentClass = this.props.collapse ? 'collapse' : 'ibox-content p-t-20';
    return <div className={contentClass}>{this.props.children}</div>;
  };

  renderIBoxContentDragable = () => {
    return (
      <div className="ibox-drag-container">
        <div className="ibox-drag-handle">
          <span>
            <FAIcon icon="bars" additionalClasses="content-drag-handle" />
          </span>
        </div>
        <div className="ibox-drag-content">{this.renderIBoxContent()}</div>
      </div>
    );
  };

  render() {
    return (
      <div className={`ibox ${this.props.iboxClass}`}>
        {this.props.showTitle ? this.titleContent() : null}
        {this.props.showAsDragable ? this.renderIBoxContentDragable() : this.renderIBoxContent()}
      </div>
    );
  }
}
